/**
 * Constructs a proxied avatar URL that goes through our backend cache.
 * This avoids hitting Google's CDN directly (which rate-limits us).
 *
 * @param userId - The person/user ID
 * @param token - Optional session token for authentication (needed for <img> tags that can't set headers)
 * @returns The proxied avatar URL, or empty string if no userId
 */
export function getProxiedAvatarUrl(
  userId: string | undefined | null,
  token?: string | null
): string {
  if (!userId || userId === '') return '';
  const base = `/api/v1/avatar/${userId}`;
  return token ? `${base}?session_token=${encodeURIComponent(token)}` : base;
}

/**
 * Gets the platform access token from sessionStorage (if available).
 * Safe to call in SSR environments.
 */
export function getStoredAccessToken(): string | null {
  try {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('platform_access_token');
    }
  } catch {
    // SSR or storage unavailable
  }
  return null;
}
